export const CUSTOMER_VAR_NONBP = 'nonbp'
export const CUSTOMER_VAR_BP = 'bp'
